module.exports = {
	"classes": [
		"press-page",
		"header-dark"
	],
	"title": "Press & Media Resources",
	"metas": {
		"description": "Press page. Company mission, press & media resources."
	},
	"opengraph": {
		"og:title": "Press & Media Resources",
		"og:description": "Press page. Company mission, press & media resources. For enquiries contact press@auth0.com",
		"og:url": "https://auth0.com/press",
		"og:image": "https://cdn.auth0.com/website/assets/pages/press/img/press-twitter-card-f7ca0bcd3f.png",
		"og:image:secure_url": "https://cdn.auth0.com/website/assets/pages/press/img/press-twitter-card-f7ca0bcd3f.png"
	},
	"twittercard": {
		"twitter:title": "Press & Media Resources",
		"twitter:description": "Press page. Company mission, press & media resources. For enquiries contact press@auth0.com",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/assets/pages/press/img/press-twitter-card-f7ca0bcd3f.png"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/press/metadata.json
// module id = 1427
// module chunks = 0